/* Cartwala Background Removal QA — unpublished-theme-only comparison.
   Local file processing: does not submit user photos to Shopify or other APIs.
   Model/wasm dependencies load over the network from their public distributors. */
(function(){
"use strict";
var script=document.querySelector("script[data-cw-background-quality]");
if(!script)return;
try{if(new URLSearchParams(location.search).get("cw_bg_quality_test")!=="1")return;}catch(error){return;}
var source=null,sourceURL=null,rawInput=null,rawDimensions=null,busy=false,results={},sequence=0,overlay;
var urls={
  css:script.dataset.cwBgCss,
  modnet:script.dataset.cwBgModnet,
  quint8:script.dataset.cwBgQ8,
  fp16:script.dataset.cwBgFp16,
  smart:script.dataset.cwBgSmart,
  repair:script.dataset.cwBgRepair,
  repairCSS:script.dataset.cwBgRepairCss
};
var models=[
  {key:"smart",name:"Smart Auto Cutout (Fast)",detail:"MODNet + automatic gentle photo enhancement • recommended"},
  {key:"modnet",name:"MODNet Original",detail:"Soft portrait alpha — Crystal Realistic"},
  {key:"quint8",name:"ISNet Lightweight",detail:"IMG.LY isnet_quint8 — current Gift Editor"},
  {key:"fp16",name:"ISNet FP16",detail:"IMG.LY isnet_fp16 — comparison candidate"}
];
var names={};
models.forEach(function(model){names[model.key]=model;});
function el(tag,cls,text){
 var node=document.createElement(tag);
 if(cls)node.className=cls;
 if(text!==undefined)node.textContent=text;
 return node;
}
function byId(id){return document.getElementById(id);}
function init(){
 var sheet=el("link");sheet.rel="stylesheet";sheet.href=urls.css;document.head.appendChild(sheet);
 var repairSheet=el("link");repairSheet.rel="stylesheet";repairSheet.href=urls.repairCSS;document.head.appendChild(repairSheet);
 overlay=el("div","cw-bgqa");
 overlay.id="cw-bgqa";
 overlay.setAttribute("role","region");
 overlay.setAttribute("aria-label","Cartwala Background Removal Model Comparison");
 overlay.innerHTML=
  '<div class="cw-bgqa-bar"><div><strong>Cartwala Background Removal QA</strong><small>Unpublished test theme • no live product changes</small></div><button type="button" id="cw-bgqa-exit">Close Test</button></div>'+
  '<div class="cw-bgqa-inner">'+
  '<h1>Cartwala Smart Cutout • Fast + Auto Enhance</h1>'+
  '<p class="cw-bgqa-intro">Choose the same original portrait for all tests. The photo is processed in this browser; only AI model files are downloaded.</p>'+
  '<div class="cw-bgqa-toolbar"><label class="cw-bgqa-pick" for="cw-bgqa-file">Choose Original Photo <input id="cw-bgqa-file" type="file" accept="image/jpeg,image/png,image/webp"></label><button id="cw-bgqa-all" class="cw-bgqa-orange" type="button" disabled>Run Smart (Fast)</button><button id="cw-bgqa-report" type="button" disabled>Save Comparison PNG</button></div>'+
  '<p id="cw-bgqa-notice" role="status" aria-live="polite">Select an original photo to begin. Large models may take several minutes on mobile.</p>'+
  '<div class="cw-bgqa-cards" id="cw-bgqa-cards"></div>'+
  '<p class="cw-bgqa-disclaimer">Transparency percentages measure the output mask, not its accuracy. Inspect hair, jewellery, saree edges, hands and clothes against both a light and a dark background. Model files are downloaded from external model hosts, but the selected photo is not sent to them.</p>'+
  '</div>';
 document.body.appendChild(overlay);
 var cards=byId("cw-bgqa-cards");
 cards.appendChild(makeCard("original","Original Photo","Unprocessed reference"));
 for(var i=0;i<models.length;i++)cards.appendChild(makeCard(models[i].key,models[i].name,models[i].detail));
 byId("cw-bgqa-exit").addEventListener("click",function(){overlay.remove();});
 byId("cw-bgqa-file").addEventListener("change",choose);
 byId("cw-bgqa-all").addEventListener("click",function(){run(["smart"]);});
 byId("cw-bgqa-report").addEventListener("click",saveReport);
 byId("cw-bgqa-fix-smart").addEventListener("click",fixSmartMissingHand);
 models.forEach(function(model){byId("cw-bgqa-run-"+model.key).addEventListener("click",function(){run([model.key]);});});
 var isDark=false;
 var toggle=el("button","cw-bgqa-background","Background: Checkerboard");
 toggle.type="button";
 toggle.addEventListener("click",function(){
  isDark=!isDark;
  overlay.classList.toggle("cw-bgqa-dark-check",isDark);
  toggle.textContent=isDark?"Background: Dark":"Background: Checkerboard";
 });
 byId("cw-bgqa-notice").after(toggle);
}
function makeCard(key,name,detail){
 var card=el("section","cw-bgqa-card");
 card.setAttribute("data-cw-bgqa-card",key);
 var header=el("div","cw-bgqa-cardhead");
 header.appendChild(el("strong","",name));
 header.appendChild(el("small","",detail));
 var stage=el("div","cw-bgqa-imagebox");
 stage.id="cw-bgqa-box-"+key;
 stage.appendChild(el("span","cw-bgqa-empty",key==="original"?"Choose your portrait":"Not processed yet"));
 var status=el("p","cw-bgqa-status",key==="original"?"Waiting for photo":"Not tested");
 status.id="cw-bgqa-status-"+key;
 card.append(header,stage,status);
 if(key!=="original"){
  var actions=el("div","cw-bgqa-cardactions");
  var runButton=el("button","cw-bgqa-run","Run "+name);
  runButton.type="button";runButton.id="cw-bgqa-run-"+key;runButton.disabled=true;
  var link=el("a","cw-bgqa-download","Download PNG");link.id="cw-bgqa-save-"+key;
  link.hidden=true;link.download="cartwala-"+key+"-cutout.png";
  actions.append(runButton,link);
  if(key==="smart"){
   var fix=el("button","cw-bgqa-repair","Fix Missing Hand / Edges");
   fix.type="button";fix.id="cw-bgqa-fix-smart";fix.disabled=true;
   actions.append(fix);
  }
  card.append(actions);
 }
 return card;
}
function notice(message,isError){
 var element=byId("cw-bgqa-notice");
 element.textContent=message;
 element.classList.toggle("cw-bgqa-error",!!isError);
}
function showImage(key,url){
 var box=byId("cw-bgqa-box-"+key);box.replaceChildren();
 var img=el("img");img.src=url;img.alt=key==="original"?"Original uploaded image":names[key].name+" transparent cutout";
 img.loading="eager";box.appendChild(img);
}
function setStatus(key,message,state){
 var node=byId("cw-bgqa-status-"+key);
 node.textContent=message;node.dataset.state=state||"idle";
}
function choose(event){
 if(busy){notice("Wait until the current model finishes.",true);return;}
 var next=event.target.files&&event.target.files[0];
 if(!next)return;
 if(!["image/png","image/jpeg","image/webp"].includes(next.type)||next.size>20*1024*1024){
  notice("Please choose a JPG, PNG or WebP image under 20 MB.",true);return;
 }
 if(sourceURL)URL.revokeObjectURL(sourceURL);
 Object.keys(results).forEach(function(k){URL.revokeObjectURL(results[k].url);});
 results={};rawInput=null;rawDimensions=null;source=next;sequence++;
 sourceURL=URL.createObjectURL(next);
 showImage("original",sourceURL);
 setStatus("original",next.name+" • "+(next.size/1024/1024).toFixed(2)+" MB","done");
 for(var i=0;i<models.length;i++){
  var key=models[i].key;
  var box=byId("cw-bgqa-box-"+key);
  box.replaceChildren(el("span","cw-bgqa-empty","Not processed yet"));
  setStatus(key,"Ready to test","idle");
  byId("cw-bgqa-save-"+key).hidden=true;
 }
 byId("cw-bgqa-all").disabled=false;byId("cw-bgqa-report").disabled=true;
 byId("cw-bgqa-fix-smart").disabled=true;
 models.forEach(function(m){byId("cw-bgqa-run-"+m.key).disabled=false;});
 notice("Ready. Tap Run Smart (Fast) for the recommended result. The other three models remain available for comparison.",false);
}
function toggleBusy(state){
 busy=state;
 byId("cw-bgqa-all").disabled=state||!source;
 byId("cw-bgqa-file").disabled=state;
 models.forEach(function(m){byId("cw-bgqa-run-"+m.key).disabled=state||!source;});
 byId("cw-bgqa-report").disabled=state||!Object.keys(results).length;
 byId("cw-bgqa-fix-smart").disabled=state||!results.smart;
}
function loadLibrary(url,globalName){
 if(typeof window[globalName]==="function")return Promise.resolve();
 return new Promise(function(resolve,reject){
  var node=el("script");
  node.src=url;node.async=true;
  node.onload=function(){
   if(typeof window[globalName]!=="function")reject(Error("Loaded library but "+globalName+" was not found"));
   else resolve();
  };
  node.onerror=function(){reject(Error("Unable to download background-removal library"));};
  document.head.appendChild(node);
 });
}

/* Pre-decode on the phone BEFORE loading a heavy AI model.
   IMG.LY's own decoder supports raw image/x-rgba8; width=...;height=...
   and therefore need not call createImageBitmap after ONNX initialization.
   No uploaded image or pixel data is transferred to a remote API. */
async function prepareRawInput(){
 if(rawInput)return rawInput;
 if(!source)throw Error("Choose an original photo first.");
 notice("Preparing source pixels locally before downloading AI models…",false);
 var bitmap=await createImageBitmap(source);
 try{
  var scale=Math.min(1,1600/Math.max(bitmap.width,bitmap.height));
  var width=Math.max(1,Math.round(bitmap.width*scale));
  var height=Math.max(1,Math.round(bitmap.height*scale));
  if(width*height>5000000)throw Error("Photo too large for mobile QA test.");
  var canvas=document.createElement("canvas");
  canvas.width=width;canvas.height=height;
  var ctx=canvas.getContext("2d",{willReadFrequently:true});
  if(!ctx)throw Error("Your browser does not support image processing canvas.");
  ctx.clearRect(0,0,width,height);
  ctx.drawImage(bitmap,0,0,width,height);
  var rgba=ctx.getImageData(0,0,width,height).data;
  // The processor recognises this image media type without requiring a
  // browser decoder. Preserve the exact photo pixel data in RGBA order.
  rawInput=new Blob([rgba],{type:"image/x-rgba8;width="+width+";height="+height});
  rawDimensions={width:width,height:height};
  canvas.width=1;canvas.height=1;
  return rawInput;
 }finally{if(bitmap.close)bitmap.close();}
}

/* Optional touch-up, only after Smart Cutout has produced its first PNG.
   The photo never leaves this browser; the restored cutout replaces the
   download and side-by-side comparison image, not the live storefront. */
async function fixSmartMissingHand(){
 if(busy||!source||!results.smart){
  notice("Run Smart (Fast) first, then restore any missing hand or dress edges.",true);
  return;
 }
 try{
  await loadLibrary(urls.repair,"CartwalaEdgeRepairQA");
  await window.CartwalaEdgeRepairQA({
   original:source,
   cutout:results.smart.blob,
   tone:window.CartwalaSmartLastReport?.tone,
   onSave:async file=>{
    let alpha,statsFailed=false;
    try{alpha=await alphaStats(file);}catch(error){
     statsFailed=true;
     alpha={transparent:"N/A",soft:"N/A",width:window.CartwalaSmartLastReport?.outputWidth||"?",height:window.CartwalaSmartLastReport?.outputHeight||"?"};
    }
    const previous=results.smart;
    const nextURL=URL.createObjectURL(file);
    results.smart={...previous,blob:file,url:nextURL,alpha,repaired:true};
    showImage("smart",nextURL);
    const save=byId("cw-bgqa-save-smart");
    save.href=nextURL;
    save.download="cartwala-hand-restored.png";
    save.hidden=false;
    byId("cw-bgqa-report").disabled=false;
    setStatus("smart","Hand / edges restored from original photo • Transparent PNG ready"+(statsFailed?" (statistics unavailable)":
     " • "+alpha.transparent+"% transparent • "+alpha.width+"×"+alpha.height+"px"),"done");
    notice("Hand repaired. Tap Download PNG for the corrected file, or Save Comparison PNG.",false);
    if(previous.url)URL.revokeObjectURL(previous.url);
   }
  });
 }catch(error){
  console.error("QA hand restoration failed",error);
  notice("Unable to open hand repair: "+(error?.message||"Unknown error"),true);
 }
}
async function run(which){
 if(busy||!source)return;
 toggleBusy(true);
 var current=sequence;
 try{
  if(which.some(function(name){return name!=="smart";}))await prepareRawInput();
  if(current!==sequence)return;
  for(var i=0;i<which.length;i++){
   if(current!==sequence)break;
   await one(which[i]);
  }
  notice("Finished attempted tests. Compare hair, jewellery, skin and saree edges; download the transparent PNGs.",false);
 }catch(error){
  notice("Could not prepare the photo on this phone: "+(error?.message||"Unknown image error"),true);
 }finally{toggleBusy(false);}
}
async function one(key){
 var model=names[key],began=performance.now(),statusMessage="";
 setStatus(key,"Loading model and preparing photo…","working");
 notice("Processing "+model.name+". Please wait; do not close this tab.",false);
 var result;
 try{
  if(key==="smart"){
   await loadLibrary(urls.smart,"CartwalaSmartAutoCutout");
   result=await window.CartwalaSmartAutoCutout(source,urls.modnet,function(message){setStatus(key,message,"working");});
  }else if(key==="modnet"){
   result=await modnet(source,function(message){setStatus(key,message,"working");});
  }else{
   var globalName=key==="fp16"?"CartwalaQAIsnetFP16":"CartwalaGiftPhoto";
   await loadLibrary(key==="fp16"?urls.fp16:urls.quint8,globalName);
   var fn=window[globalName];
   result=await fn(rawInput||source,"cutout",function(message){var msg=String(message||"");setStatus(key,/0%/.test(msg)?"Loading "+model.name+" model… This may take a few minutes on your phone.":msg,"working");});
  }
  if(!(result instanceof Blob)||!result.size)throw Error("Model returned no transparent image");
  var alpha,statsFailed=false;
  try{
   alpha=await alphaStats(result);
  }catch(statsError){
   console.warn("QA transparent PNG produced, but mobile statistics could not be calculated:",statsError);
   statsFailed=true;
   alpha={transparent:"N/A",soft:"N/A",width:rawDimensions?.width||"?",height:rawDimensions?.height||"?"};
  }
  var duration=(performance.now()-began)/1000;
  if(results[key])URL.revokeObjectURL(results[key].url);
  var url=URL.createObjectURL(result);
  results[key]={blob:result,url:url,seconds:duration,alpha:alpha};
  showImage(key,url);
  statusMessage=statsFailed?duration.toFixed(1)+" s • Cutout PNG ready (statistics unavailable on this device)":duration.toFixed(1)+" s • "+alpha.transparent+"% transparent • "+alpha.soft+"% soft-alpha • "+alpha.width+"×"+alpha.height+"px";
  if(key==="smart"&&window.CartwalaSmartLastReport){
   var report=window.CartwalaSmartLastReport;
   statusMessage+=" • Auto Enhance: "+(report.changes?.length?report.changes.join(", "):"not needed");
   statusMessage+=" • Original "+report.originalWidth+"×"+report.originalHeight+"px";
   statusMessage+=" • Edge Clean: "+(report.refineSkipped?"skipped":(report.edgePixelsRefined||0)+" pixels");
   if(report.reviewHands){
    statusMessage+=" • Check sleeve / hand gaps";
    notice("Some narrow gaps need checking. They may be real background, or incorrectly cut sleeves. Use Fix Missing Hand / Edges before printing.",false);
   }
  }
  setStatus(key,statusMessage,"done");
  var link=byId("cw-bgqa-save-"+key);
  link.href=url;link.hidden=false;
  if(key==="smart")byId("cw-bgqa-fix-smart").disabled=false;
 }catch(error){
  console.error("Cartwala QA "+key+" failed",error);
  var issue=error&&error.message?error.message:"Unknown model error";
  if(/decode|decoded|memory|allocation/i.test(issue))issue+=". Try refreshing this page and running only "+model.name+" first.";
  setStatus(key,"Could not run: "+issue,"error");
  notice(model.name+" failed on this device. Other models can still be tested.",true);
 }
}
async function alphaStats(blob){
 var bitmap=await createImageBitmap(blob);
 var w=bitmap.width,h=bitmap.height,max=640,scale=Math.min(1,max/Math.max(w,h));
 var sw=Math.max(1,Math.round(w*scale)),sh=Math.max(1,Math.round(h*scale));
 var canvas=document.createElement("canvas");canvas.width=sw;canvas.height=sh;
 var ctx=canvas.getContext("2d",{willReadFrequently:true});ctx.clearRect(0,0,sw,sh);ctx.drawImage(bitmap,0,0,sw,sh);
 if(bitmap.close)bitmap.close();
 var px=ctx.getImageData(0,0,sw,sh).data,transparent=0,soft=0,total=px.length/4;
 for(var i=3;i<px.length;i+=4){if(px[i]<=8)transparent++;else if(px[i]<247)soft++;}
 canvas.width=1;canvas.height=1;
 return {width:w,height:h,transparent:(transparent/total*100).toFixed(1),soft:(soft/total*100).toFixed(1)};
}
async function modnet(file,onStatus){
 // Reuse the input already decoded before AI model initialization.
 // Avoid a second createImageBitmap(file), which may fail on low-memory phones.
 if(!rawInput||!rawDimensions)await prepareRawInput();
 var w=rawDimensions.width,h=rawDimensions.height;
 var rgba=new Uint8ClampedArray(await rawInput.arrayBuffer());
 if(rgba.length!==w*h*4)throw Error("Prepared RGBA image dimensions do not match.");
 var canvas=document.createElement("canvas");canvas.width=w;canvas.height=h;
 var ctx=canvas.getContext("2d",{willReadFrequently:true});
 if(!ctx)throw Error("Image canvas could not be created.");
 ctx.putImageData(new ImageData(rgba,w,h),0,0);
 // Canvas keeps its copy of the image; the original buffer is transferred
 // to the worker without decoding the original file again.
 var worker;
 try{worker=new Worker(urls.modnet);}catch(error){
  var fetched=await fetch(urls.modnet);
  if(!fetched.ok)throw Error("MODNet worker script could not load");
  var blobUrl=URL.createObjectURL(await fetched.blob());
  try{worker=new Worker(blobUrl);worker._cwBlobUrl=blobUrl;}catch(another){URL.revokeObjectURL(blobUrl);throw another;}
 }
 var output;
 try{
  output=await new Promise(function(resolve,reject){
   var timer=setTimeout(function(){reject(Error("MODNet took over 4 minutes"));},240000);
   function finish(err,value){
    clearTimeout(timer);
    worker.onmessage=null;worker.onerror=null;
    if(err)reject(err);else resolve(value);
   }
   worker.onmessage=function(event){
    var data=event.data||{};
    if(data.stage){onStatus(data.stage==="removing"?"MODNet removing background…":"MODNet preparing model…");return;}
    if(data.error){finish(Error(data.error));return;}
    if(!data.mask){finish(Error("No matte returned"));return;}
    finish(null,data);
   };
   worker.onerror=function(){finish(Error("MODNet worker could not load or run"));};
   onStatus("MODNet loading and preparing soft-alpha mask…");
   worker.postMessage({id:1,width:w,height:h,rgba:rgba.buffer},[rgba.buffer]);
  });
 }finally{
  worker.terminate();
  if(worker._cwBlobUrl)URL.revokeObjectURL(worker._cwBlobUrl);
 }
 var mask=new Uint8Array(output.mask);
 if(mask.length!==w*h)throw Error("Unexpected MODNet mask dimensions");
 var pixels=ctx.getImageData(0,0,w,h);
 for(var j=0;j<mask.length;j++)pixels.data[j*4+3]=mask[j];
 ctx.putImageData(pixels,0,0);
 var png=await new Promise(function(resolve,reject){
  canvas.toBlob(function(blob){if(blob)resolve(blob);else reject(Error("PNG export failed"));},"image/png");
 });
 canvas.width=1;canvas.height=1;
 return png;
}
async function saveReport(){
 if(busy||!source)return;
 var entries=[{key:"original",label:"Original Photo"},{key:"smart",label:"Cartwala Smart Fast"},{key:"modnet",label:"MODNet Original"},{key:"fp16",label:"ISNet FP16"},{key:"quint8",label:"ISNet Lightweight"}];
 var canvas=document.createElement("canvas");canvas.width=1200;canvas.height=2050;
 var ctx=canvas.getContext("2d");ctx.fillStyle="#ffffff";ctx.fillRect(0,0,1200,1480);
 ctx.fillStyle="#1b1b1b";ctx.font="bold 35px Arial";ctx.fillText("CARTWALA • BACKGROUND REMOVAL QA",35,57);
 ctx.font="17px Arial";ctx.fillStyle="#555";ctx.fillText("Comparison only - visual review required for the best model",35,89);
 for(var i=0;i<entries.length;i++){
  var entry=entries[i],x=35+(i%2)*582,y=115+Math.floor(i/2)*640,boxW=548,boxH=515;
  ctx.fillStyle="#fff";ctx.fillRect(x,y,boxW,boxH);
  var checker=24;
  for(var yy=0;yy<boxH;yy+=checker)for(var xx=0;xx<boxW;xx+=checker){
   ctx.fillStyle=((Math.floor(xx/checker)+Math.floor(yy/checker))%2===0)?"#f2f2f2":"#dedede";
   ctx.fillRect(x+xx,y+yy,checker,checker);
  }
  var blob=entry.key==="original"?source:results[entry.key]?.blob;
  if(blob){
   try{
    var bmp=await createImageBitmap(blob);
    var fit=Math.min(boxW/bmp.width,boxH/bmp.height);
    var iw=bmp.width*fit,ih=bmp.height*fit;
    ctx.drawImage(bmp,x+(boxW-iw)/2,y+(boxH-ih)/2,iw,ih);
    if(bmp.close)bmp.close();
   }catch(error){}
  }else{ctx.fillStyle="#6b6b6b";ctx.font="19px Arial";ctx.fillText("Not processed",x+180,y+255);}
  ctx.fillStyle="#1b1b1b";ctx.font="bold 24px Arial";ctx.fillText(entry.label,x,y+549);
  var details=results[entry.key];
  ctx.font="17px Arial";ctx.fillStyle="#555";
  if(details)ctx.fillText(details.alpha.transparent==="N/A"?details.seconds.toFixed(1)+"s • Statistics unavailable":details.seconds.toFixed(1)+"s • "+details.alpha.transparent+"% transparent • "+details.alpha.soft+"% soft edges",x,y+582);
 }
 ctx.fillStyle="#666";ctx.font="17px Arial";
 ctx.fillText("Hair • clothing • saree • jewellery • hands: check edges manually",35,2029);
 var blob=await new Promise(function(resolve){canvas.toBlob(resolve,"image/png");});
 canvas.width=1;canvas.height=1;
 if(!blob){notice("Could not save the comparison PNG.",true);return;}
 var url=URL.createObjectURL(blob),a=el("a");a.href=url;a.download="cartwala-background-quality-comparison.png";
 document.body.appendChild(a);a.click();a.remove();setTimeout(function(){URL.revokeObjectURL(url);},10000);
 notice("Comparison PNG saved. Send it here for a detailed quality verdict.",false);
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});
else init();
})();
